import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	voteForIdeaTooltip: {
		id: 'polaris-ideas.idea-view.smartlink-idea-view.field.vote-for-idea-tooltip',
		defaultMessage: 'Vote for this idea',
		description: 'Tooltip for play field button',
	},
});
